import { ScheduleResource } from "domain-entities";
import { v4 } from "uuid";

export function createScheduleResource(): ScheduleResource {
	return {
		id: v4(),
		name: "",
	};
}
